import React from "react";
import { Route, Routes } from "react-router-dom";
import Organization from "../module/Organization/Component/organization";
import MachineRoutes from "../module/MachineConfiguration/machineRoutes";
import UnderConstruction from "../../BasicComponent/Components/underConstruction";
import Role from "../module/Role/Component/rolecomponent";
import User from "../module/User/Component/user";
import Product from "../module/Product/Component/product";
import IotGateWayComponent from "../module/IotGateWay/Components/iotGateWayComponent";

function ConfigurationRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Organization />} />
      <Route path="product/*" element={<Product />} />
      <Route path="iot-gateway/*" element={<IotGateWayComponent />} />
      <Route path="machine/*" element={<MachineRoutes />} />
      <Route path="role/*" element={<Role />} />
      <Route path="user/*" element={<User />} />
      <Route path="user-access/*" element={<UnderConstruction />} />
    </Routes>
  );
}

export default ConfigurationRoutes;
